import config from "@/config";
import http from "@/utils/request";

export default {
	order: {
		list: {
			url: `${config.API_URL}/admin/order/getDistributionList`,
			name: "获取分销订单列表",
			get: async function (data = {}, config = {}) {
				return await http.get(
					this.url,
					data,
					Object.assign(config, { timeout: 300000 })
				);
			},
		},
	},
	investor: {
		list: {
			url: `${config.API_URL}/admin/investor/list`,
			name: "获取投资人列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/investor/store`,
			name: "新增编辑投资人",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/investor/detail`,
			name: "获取投资人详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/investor/del`,
			name: "删除投资人",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	place: {
		list: {
			url: `${config.API_URL}/admin/place/list`,
			name: "获取场地方列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/place/store`,
			name: "新增编辑场地方",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/place/detail`,
			name: "获取场地方详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/place/del`,
			name: "删除场地方",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	cooperation: {
		list: {
			url: `${config.API_URL}/admin/business/index`,
			name: "获取商务合作列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/business/store`,
			name: "编辑商务合作",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/business/del`,
			name: "删除商务合作",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	payment: {
		list: {
			url: `${config.API_URL}/api/ly/payment/channel/page`,
			name: "获取支付通道列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		add: {
			url: `${config.API_URL}/api/ly/payment/channel`,
			name: "新增支付通道",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/api/ly/payment/channel`,
			name: "修改支付通道",
			put: async function (data = {}) {
				return await http.put(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/api/ly/payment/channel`,
			name: "获取支付通道详情",
			get: async function (data = {}) {
				return await http.get(`${this.url}/${data}`);
			},
		},
		delete: {
			url: `${config.API_URL}/api/ly/payment/channel/`,
			name: "删除支付通道",
			delete: async function (data = {}) {
				return await http.delete(`${this.url}/${data}`);
			},
		},
	},
	settlement: {
		list: {
			// url: `${config.API_URL}/api/ly/settlement/period/page`,
			url: `${config.API_URL}/admin/report/settlementPeriod`,
			name: "佣金账期审核列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		audit: {
			url: `${config.API_URL}/api/ly/settlement/period/audit`,
			name: "核准佣金",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		audits: {
			url: `${config.API_URL}/admin/commission_settlement_period/audit`,
			name: "批量核准佣金",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		updateAmount: {
			url: `${config.API_URL}/api/ly/settlement/period/updateAmount`,
			name: "调整佣金",
			put: async function (data = {}) {
				return await http.put(this.url, data);
			},
		},
		log: {
			url: `${config.API_URL}/admin/report/settlementPeriodLog`,
			name: "操作记录",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		export: {
			// url: `${config.API_URL}/api/ly/settlement/period/export`,
			url: `${config.API_URL}/admin/report/settlementPeriod`,
			name: "导出佣金账期审核",
			post: async function (params) {
				return await http.post(this.url, params, {
					responseType: "blob",
				});
			},
		},
		record: {
			url: `${config.API_URL}/api/ly/settlement/period/orderList`,
			name: "查看佣金账期订单",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		storeSettlementPeriodLog: {
			url: `${config.API_URL}/admin/report/storeSettlementPeriodLog`,
			name: "添加账期备注",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		updateBankCard: {
			url: `${config.API_URL}/admin/report/storeSettlementPeriodCard`,
			name: "修改银行卡",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	invoice: {
		list: {
			url: `${config.API_URL}/api/ly/invoice/page`,
			name: "发票管理列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		add: {
			url: `${config.API_URL}/api/ly/invoice/addInvoice`,
			name: "添加发票",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		confirm: {
			url: `${config.API_URL}/api/ly/invoice/confirmRelease`,
			name: "确认发放",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		log: {
			url: `${config.API_URL}/api/ly/invoice/log`,
			name: "操作日志",
			get: async function (data = {}) {
				return await http.get(`${this.url}/${data}`);
			},
		},
		delete: {
			url: `${config.API_URL}/api/ly/invoice/deleteInvoice`,
			name: "删除发票",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	withdrawal: {
		list: {
			url: `${config.API_URL}/api/ly/withdrawal/page`,
			name: "分页数据",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		operate: {
			url: `${config.API_URL}/api/ly/withdrawal/operate`,
			name: "操作",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		log: {
			url: `${config.API_URL}/api/ly/withdrawal/log`,
			name: "操作记录",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
};
